import reducer from './reducer';
export { reducer };



// WEBPACK FOOTER //
// ./src/store/modules/drawer/index.ts